<template>
    <main>
        <div class="card">
            <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                    <p v-if="statusCode == 0" class="mb-0">افزودن نقش جدید</p>
                    <p v-else class="mb-0">ویرایش نقش</p>
                </div>
            </div>
            <div class="card-body">
                <p class="text-uppercase text-sm d-none">اطلاعات نقش</p>
                <div class="row">
                    <div class="col-md-6">
                        <label for="firstname" class="form-control-label required">عنوان نقش</label>
                        <input class="form-control" id="txt_title"
                               v-model.trim="modelValue.title"
                               type="text" autocomplete="off"
                               :readonly="statusCode == 1 || editable != true" />
                    </div>
                    <div class="col-md-6">
                        <label for="txt_desc" class="form-control-label">توضیحات</label>
                        <textarea class="form-control" id="txt_desc" v-model.trim="modelValue.descriptions" 
                                  type="text" :readonly="editable != true"></textarea>
                    </div>
                    <div class="col-md-6">
                        <label for="accessLevel" class="form-control-label required">سطح استفاده</label>
                        <select class="form-control" v-model="modelValue.accessLevelEnum"  :disabled="editable != true">
                            <option v-for="item in dataList.accessLevelList" :value="item.id" :key="item.id">{{item.title}}</option>
                        </select>
                    </div>
                </div>
                <hr class="horizontal dark" />
                <template v-if="v.$error">
                    <show-errors :model-value="v.$errors"></show-errors>
                    <hr class="horizontal dark" />
                </template>
                <button v-if="editable == true" type="button"
                        :disabled="submitButtonStatus == false"
                        class="btn bg-gradient-success mb-0"
                        @click="submit()">
                    ثبت تغییرات
                </button>
                <router-link :to="'/userAccessGroup-manager'" class="btn bg-gray-400 me-3 float-start mb-0">
                    بازگشت
                </router-link>
            </div>
        </div>
    </main>
</template>
<script>
    import BaseInformationService from "@/services/BaseInformation/BaseInformation-service";

    export default {
        name: "accessGroupForm",
        emits: "onSubmitFormCallback",
        props: {
            modelValue: {},
            editable: false,
            statusCode: 0,
            submitButtonStatus: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                formPermCode: 3002,
                formPermCode_forChangePerson: 3003,
                v: this.$useVuelidate(),
                dataList: {
                    accessLevelList: []
                }
            };
        },
        components: {},
        created() {

            //BaseInformationService.getListAccessLevel()
            //    .then(response => {
            //        let result = response.data;

            //        if (!result.isSuccess) {
            //            this.$toast.error(result.message);
            //        }
            //        else {
            //            this.dataList.accessLevelList = result.data;
            //        }
            //    })
            //    .catch(e => {
            //        console.log(e);
            //    });
        },
        methods: {
            submit() {

                this.v.$validate();
                if (this.v.$error) { return; }

                this.$emit('onSubmit-form-callback', this.modelValue);
            },
        },
        watch: {
        },
        mounted() {
        },
        validations() {
            return {
                modelValue: {
                    title: { required: this.$reqVal("عنوان") },
                }
            };
        }

    };
</script>
